<template>
  <FindDialog
    ref="findDialog"
    title="Select Report Template"
    :forms="forms"
    :loading="loading"
    :custom-groups="customGroups"
    show-default-filters
    @load="loadTemplates"
  >
    <tip
      v-if="can(permissions.canModifyForms)"
      name="moduleReportsAddFormsNotice"
      wrapper-class="q-pa-md"
      label="Generate different types of reports by adding new templates to your business collection."
      :inline-actions="false"
    >
      <template #action>
        <q-btn
          label="Add Templates"
          no-caps
          color="white"
          text-color="black"
          @click="goTo('forms/add')"
        />
      </template>
    </tip>

    <!-- Each group of form revisions -->
    <template #form="{ form, refKey }">
      <FormGroup
        :key="refKey"
        :form="form"
        :selected="current"
        without-timestamp
        without-border
        @form-click="selectRevision"
      />
    </template>
  </FindDialog>
</template>

<script>
import FindDialog from 'components/app/forms/partials/list/Dialog'
import FormGroup from 'components/app/forms/partials/list/group/Group'

export default {
  components: {
    FindDialog, FormGroup
  },
  props: {
    current: {
      type: Number,
      default: null
    }
  },
  emits: ['selected'],
  data () {
    return {
      forms: [],
      lastUsed: [],
      loading: false
    }
  },
  computed: {
    customGroups () {
      return [
        {
          title: 'Last Used',
          reference_ids: this.lastUsed
        }
      ]
    }
  },
  methods: {
    open () {
      this.$refs.findDialog.open()
    },
    async loadTemplates () {
      if (this.forms.length > 0) {
        return
      }

      this.loading = true
      const { status, payload } = await this.$get('v1/reportingsystem/forms/available')
      this.loading = false
      if (status === 'success') {
        this.forms = payload.templates
        this.lastUsed = payload.last_used
      }
    },
    reloadTemplates () {
      this.$refs.findDialog.refresh()
    },
    selectRevision (revision) {
      this.$emit('selected', revision)
      this.$refs.findDialog.close()
    }
  },
  mounted () {
    this.$bus.on('forms:reload', this.reloadTemplates)
  },
  beforeUnmount () {
    this.$bus.off('forms:reload', this.reloadTemplates)
  }
}
</script>
